
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_lm6vo_1b2gu_97",
  "layout-wrapper": "awsui_layout-wrapper_lm6vo_1b2gu_98",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_1b2gu_104",
  "layout": "awsui_layout_lm6vo_1b2gu_98",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_1b2gu_115",
  "layout-main": "awsui_layout-main_lm6vo_1b2gu_119",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_1b2gu_125",
  "unfocusable": "awsui_unfocusable_lm6vo_1b2gu_130",
  "drawer": "awsui_drawer_lm6vo_1b2gu_134",
  "drawer-mobile": "awsui_drawer-mobile_lm6vo_1b2gu_140",
  "drawer-closed": "awsui_drawer-closed_lm6vo_1b2gu_143",
  "opaque-background": "awsui_opaque-background_lm6vo_1b2gu_150",
  "drawer-content": "awsui_drawer-content_lm6vo_1b2gu_154",
  "toggle": "awsui_toggle_lm6vo_1b2gu_179",
  "visual-refresh-toggle": "awsui_visual-refresh-toggle_lm6vo_1b2gu_184",
  "visual-refresh-toggle-type-tools": "awsui_visual-refresh-toggle-type-tools_lm6vo_1b2gu_188",
  "visual-refresh-toggle-type-navigation": "awsui_visual-refresh-toggle-type-navigation_lm6vo_1b2gu_191",
  "button-toggles-container": "awsui_button-toggles-container_lm6vo_1b2gu_201",
  "button-toggles-container-is-hidden": "awsui_button-toggles-container-is-hidden_lm6vo_1b2gu_206",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_1b2gu_220",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_1b2gu_225",
  "content-wrapper": "awsui_content-wrapper_lm6vo_1b2gu_229",
  "content-overlapped": "awsui_content-overlapped_lm6vo_1b2gu_233",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_1b2gu_237",
  "navigation-toggle": "awsui_navigation-toggle_lm6vo_1b2gu_242",
  "tools-toggle": "awsui_tools-toggle_lm6vo_1b2gu_247",
  "navigation": "awsui_navigation_lm6vo_1b2gu_242",
  "navigation-close": "awsui_navigation-close_lm6vo_1b2gu_259",
  "tools": "awsui_tools_lm6vo_1b2gu_247",
  "tools-close": "awsui_tools-close_lm6vo_1b2gu_271",
  "notifications": "awsui_notifications_lm6vo_1b2gu_275",
  "breadcrumbs": "awsui_breadcrumbs_lm6vo_1b2gu_220",
  "content": "awsui_content_lm6vo_1b2gu_225",
  "panel-wrapper-outer": "awsui_panel-wrapper-outer_lm6vo_1b2gu_287",
  "panel-wrapper-inner": "awsui_panel-wrapper-inner_lm6vo_1b2gu_288",
  "mobile": "awsui_mobile_lm6vo_1b2gu_297",
  "open": "awsui_open_lm6vo_1b2gu_303"
};
  